import request from '@/router/axios'
import env from '@/config/env'

/**
 * 在修改线路信息或修改站点规则或修改价格方案，运营可以调用此接口修改班次信息
 */
export const updateFlightInfo = (data) => {
  return request({
    url: env.ferryUrl + '/commonAdmin/updateFlightInfo',
    method: 'POST',
    data
  })
}

/**
 * 查询站点id所在城市的服务区域
 */
export const queryStationAreaId = (stationId) => {
  return request({
    url: env.ferryUrl + `/merchantPriceAdmin/queryAreaCoverageVoByStationAreaId/${stationId}`,
    method: 'POST'
  })
}

/**
 * 查询当前供应商及其下属供应商
 */
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    // url:'http://192.168.1.131:38000/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET'
  })
}

/**
 * 查询全部供应商
 * @param
 */
export const getAllMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllMerchant',
    // url:'http://192.168.1.131:38000/merchantPriceAdmin/getAllMerchant',
    method: 'GET'
  })
}

/**
 * 分页查询绑定供应商
 * @param data
 */
export const queryMerchantPricePage = (data) => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/queryMerchantPricePage',
    // url:'http://192.168.1.131:38000/merchantPriceAdmin/queryMerchantPricePage',
    method: 'POST',
    data
  })
}

/**
 * 根据供应商查询线路
 * @param merchantId
 */
export const queryLineByMerchantId = (merchantId) => {
  return request({
    url: env.ferryUrl + `/merchantPriceAdmin/queryLineByMerchantId/${merchantId}`,
    // url:`http://192.168.1.131:38000/merchantPriceAdmin/queryLineByMerchantId/${merchantId}`,
    method: 'PUT'
  })
}

/**
 * 根据线路查询站点规则
 * @param lineId
 */
export const queryStationRuleByLineId = (lineId) => {
  return request({
    url: env.ferryUrl + `/merchantPriceAdmin/queryStationRuleByLineId/${lineId}`,
    // url:`http://192.168.1.131:38000/merchantPriceAdmin/queryStationRuleByLineId/${lineId}`,
    method: 'PUT'
  })
}

/**
 * 根据站点规则id查询站点规则详情
 * @param stationRuleId
 */
export const queryStationRuleById = (stationRuleId) => {
  return request({
    url: env.ferryUrl + `/merchantPriceAdmin/queryStationRuleById/${stationRuleId}`,
    // url:`http://192.168.1.131:38000/merchantPriceAdmin/queryStationRuleById/${stationRuleId}`,
    method: 'PUT'
  })
}

/**
 * 查看绑定供应商详情
 * @param merchantPriceId
 */
export const queryMerchantPriceDetail = (merchantPriceId) => {
  return request({
    url: env.ferryUrl + `/merchantPriceAdmin/queryMerchantPriceDetail/${merchantPriceId}`,
    // url:`http://192.168.1.131:38000/merchantPriceAdmin/queryMerchantPriceDetail/${merchantPriceId}`,
    method: 'PUT'
  })
}

/**
 * 查询全部线路
 * @param
 */
export const queryAllLine = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/queryAllLine',
    // url:'http://192.168.1.131:38000/merchantPriceAdmin/queryAllLine',
    method: 'GET'
  })
}

/**
 * 编辑供应商
 * @param data
 */
export const editMerchantPrice = (data) => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/editMerchantPrice',
    // url:'http://192.168.1.131:38000/merchantPriceAdmin/editMerchantPrice',
    method: 'POST',
    data
  })
}

/**
 * 编辑供应商回显站点规则
 * @param data
 */
export const BackStationRule = (merchantPriceId) => {
  return request({
    url:
      env.ferryUrl + `/merchantPriceAdmin/queryEditMerchantPriceBackStationRule/${merchantPriceId}`,
    // url:`http://192.168.1.131:38000/merchantPriceAdmin/queryEditMerchantPriceBackStationRule/${merchantPriceId}`,
    method: 'PUT'
  })
}

/**
 * 删除绑定供应商
 * @param merchantPriceId
 */
export const deleteMerchantPrice = (merchantPriceId) => {
  return request({
    url: env.ferryUrl + `/merchantPriceAdmin/deleteMerchantPrice/${merchantPriceId}`,
    // url:`http://192.168.1.131:38000/merchantPriceAdmin/deleteMerchantPrice/${merchantPriceId}`,
    method: 'PUT'
  })
}

/**
 * 根据供应商查询价格方案
 * @param merchantPriceId
 */
export const queryPriceMethodByMerchantId = (merchantPriceId) => {
  return request({
    url: env.ferryUrl + `/merchantPriceAdmin/queryPriceMethodByMerchantId/${merchantPriceId}`,
    // url:`http://192.168.1.131:38000/merchantPriceAdmin/queryPriceMethodByMerchantId/${merchantPriceId}`,
    method: 'PUT'
  })
}

/**
 * 根据供应商查询价格方案
 * @param data
 */
export const queryPriceMethodPage = (data) => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/queryPriceMethodPage',
    // url:'http://192.168.1.131:38000/merchantPriceAdmin/queryPriceMethodPage',
    method: 'POST',
    data
  })
}

/**
 * 添加绑定供应商关系
 * @param data
 */
export const addMerchantPrice = (data) => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/addMerchantPrice',
    // url:'http://192.168.1.131:38000/merchantPriceAdmin/addMerchantPrice',
    method: 'POST',
    data
  })
}

/**
 * 获取价格方案详情
 * @param id
 */
export const priceDetail = (id) => {
  return request({
    url: env.ferryUrl + `/priceMethod/detail?id=${id}`,
    // url:`http://192.168.1.142:38000/priceMethod/detail?id=${id}`,
    method: 'GET'
  })
}

/**
 * 判断供应商在站点是否有计价模型
 * @param merchantId stationId pickupType
 */
export const judgeMerchantBindPriceModule = (merchantId, stationId, pickupType) => {
  return request({
    url:
      env.ferryUrl +
      `/merchantPriceAdmin/judgeMerchantBindPriceModule/${merchantId}/${stationId}/${pickupType}`,
    // url:`http://192.168.1.142:38000/merchantPriceAdmin/judgeMerchantBindPriceModule/{merchantId}/{stationId}/{pickupType}`,
    method: 'PUT'
  })
}

/**
 * 查询供应商及其下属供应商线路
 * @param
 */
export const queryAllLowLine = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/queryAllLowLine',
    // url:'http://192.168.1.131:38000/merchantPriceAdmin/queryAllLowLine',
    method: 'GET'
  })
}

/**
 * 查找该供应商在该站点对应接送类型的区域
 * @param
 */
export const queryAreaCoverageVoByStationId = (merchantId, stationId, pickupType) => {
  return request({
    url:
      env.ferryUrl +
      `/merchantPriceAdmin/queryAreaCoverageVoByStationId/v2/${merchantId}/${stationId}/${pickupType}`,
    // url:`http://192.168.1.131:38000/merchantPriceAdmin/queryAreaCoverageVoByStationId/${merchantId}/${stationId}/${pickupType}`,
    method: 'POST'
  })
}

/**
 * 查询推荐站点
 * @param
 */
export const queryStationId = (stationId, stationRuleId, rule, pickupType, areaNo) => {
  return request({
    url:
      env.ferryUrl +
      `/merchantPriceAdmin/queryRecommendStationList/${stationId}/${stationRuleId}/${rule}/${pickupType}/${areaNo}`,
    // url:`http://192.168.1.131:38000/merchantPriceAdmin/queryRecommendStationList/${stationId}/${stationRuleId}/${rule}/${pickupType}/${areaNo}`,
    method: 'POST'
  })
}
/**
 * 启停绑定供应商
 * @param
 */
export const changeEnabled = (params) => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/changeEnabled',
    method: 'PUT',
    params
  })
}
